/*New Product Swatch Js*/
function handleEvent(t) {
    var n = t.closest('[data-product-options]');
    var elements = n.querySelectorAll('.t4s-pr-color__item');
    elements.forEach(function(element) {
        element.classList.remove("is-swatch--selected");
    });
    t.classList.add("is-swatch--selected");
    var o,
        a,
        p_id = t.getAttribute('data-pid'),
        img = t.getAttribute('data-img'),
        img_2 = t.getAttribute('data-img-2'),
        vid = t.getAttribute('data-vid'),
        Url = t.getAttribute('data-url'),
        price = t.getAttribute('data-price'),
        comparePrice = t.getAttribute('data-compare-price'),
        available = t.getAttribute('data-available'),
        discount = t.getAttribute('data-discount'),
        onsale = t.getAttribute('data-onsale'),
        title = t.getAttribute('data-title'),
        soldOutElement = n.querySelector('.grid__item-image-wrapper'),
        pr_price = n.querySelector('.grid-product__price'),
        pr_img = n.querySelector('.grid__image-ratio img'),
        pr_img_2 = n.querySelector('.grid-product__secondary-image img'),
        pr_href = n.querySelector('.grid-product__link'),
        pr_title = n.querySelector('.grid-product__title'),
        v_data = n.querySelector('.product-stone-color-options');

        if(p_id !=""){
            soldOutElement = n.querySelector('.grid-product__link');
        }
        if(img != "" && pr_img){
            pr_img.srcset = img;
            pr_img.src = img;
        }
        if(img_2 != "" && pr_img_2){
            pr_img_2.srcset = img_2;
            pr_img_2.src = img_2;
        }
        if(Url != "" && pr_href){
            pr_href.href = Url;
        }
        if(price != "" && pr_price){
            var priceHtml = '';
            if (onsale == 'yes') {
                priceHtml += '<span class="visually-hidden">Regular price</span>';
                priceHtml += '<span class="grid-product__price--original">' + comparePrice + '</span>';
                priceHtml += '<span class="visually-hidden">Sale price</span>';
            }
            priceHtml += " ";
            priceHtml += price;
            if (onsale == 'yes') {
                var priceNum = parseFloat(price.replace(/[^\d.-]/g, ''));
                var comparePriceNum = parseFloat(comparePrice.replace(/[^\d.-]/g, ''));
                if (comparePriceNum > priceNum) {
                    var discountDecimal = ((comparePriceNum - priceNum) / comparePriceNum) * 100;
                  var discountRounded = Math.round(discountDecimal / 5) * 5;
                  var savedAmount = discountRounded + '%';
                    priceHtml += '<br><span class="grid-product__price--savings saving-off">' + savedAmount + ' OFF</span>';
                }
            }
            pr_price.innerHTML = priceHtml;
        }
        if(title != "" && pr_title){
            pr_title.innerHTML = title;
        }
        if(vid != "" && v_data){
            v_data.style.display = "flex";
            v_data.querySelector('.num').innerHTML = vid;
        }
        if(vid == "" && v_data){
            v_data.style.display = "none";
        }
        if(available == "false" && soldOutElement){
            const htmlContent = '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>';
            const sold_tag = n.querySelector('.grid-product__tag--sold-out');
            if(sold_tag){
              n.querySelector('.grid-product__tag--sold-out').remove();
            }
            soldOutElement.insertAdjacentHTML('beforebegin', htmlContent);
        }
        if(available == "true"){
            const sold_tag = n.querySelector('.grid-product__tag--sold-out');
            if(sold_tag){
              n.querySelector('.grid-product__tag--sold-out').remove();
            }
        }
        // Handle discount banner
        var discountBanner = n.querySelector('.label-div.discount-data');
        if(discountBanner) {
            if(discount == "yes") {
                discountBanner.style.display = "flex";
            } else {
                discountBanner.style.display = "none";
            }
        }
        
        // Handle SALE tag
        const sale_tag = n.querySelector('.grid-product__tag--sale');
        if(onsale == "yes" && available == "true"){
            if(!sale_tag){
                const saleHtmlContent = '<div class="grid-product__tag grid-product__tag--sale">Sale</div>';
                const insertPoint = n.querySelector('.grid-product__image-mask');
                if (insertPoint) {
                  insertPoint.insertAdjacentHTML('afterbegin', saleHtmlContent);
                }
            }
        } else {
            if(sale_tag){
                sale_tag.remove();
            }
        }
        
        // Handle custom badges (NEW, BEST SELLER, COMING SOON, etc.)
        var customLabel = t.getAttribute('data-custom-label');
        var custom_badge = n.querySelector('.grid-product__tag--custom');

        if(customLabel && customLabel.trim() != ""){
            if(!custom_badge){
                // Create badge if it doesn't exist - using safe DOM methods
                const badgeDiv = document.createElement('div');
                badgeDiv.className = 'grid-product__tag grid-product__tag--custom';
                if(customLabel === 'Coming Soon'){
                    badgeDiv.className += ' grid-product__tag--coming-soon';
                }
                badgeDiv.textContent = customLabel; // Safe - auto-escapes
                const insertPoint = soldOutElement || n.querySelector('.grid-product__link') || n.querySelector('.grid__item-image-wrapper');
                if(insertPoint && insertPoint.parentNode){
                    insertPoint.parentNode.insertBefore(badgeDiv, insertPoint);
                }
            } else {
                // Update existing badge text and show it
                custom_badge.textContent = customLabel;
                custom_badge.style.display = "block";
                // Add or remove Coming Soon class
                if(customLabel === 'Coming Soon'){
                    custom_badge.classList.add('grid-product__tag--coming-soon');
                } else {
                    custom_badge.classList.remove('grid-product__tag--coming-soon');
                }
            }
        } else {
            // Hide custom badge if no label
            if(custom_badge){
                custom_badge.style.display = "none";
            }
        }
}

/*
 * Update free gift unique ID on each add-to-cart click
 * Prevents consolidation when clicking "Add to Cart" multiple times without page refresh
 *
 * The Liquid template generates _gift_item_id once at page load.
 * This handler updates it to a new unique value on each click,
 * ensuring each add creates a separate cart line item.
 */
(function() {
    'use strict';

    document.addEventListener('click', function(evt) {
        var button = evt.target.closest('[data-add-to-cart]');
        if (!button) return;

        var form = button.closest('form');
        if (!form) return;

        var giftIdInput = form.querySelector('input[name="properties[_gift_item_id]"]');
        if (giftIdInput) {
            // Update to new unique ID before form submits
            giftIdInput.value = Date.now().toString();
        }
    }, true); // Capture phase - runs before theme's form submit handler
})();

/*
 * Metal Swatch Image Prefetch on Viewport Entry
 * Preloads product images as products scroll into viewport
 * Eliminates ~1200ms loading delay on first click
 * Desktop-only (disabled on mobile to conserve data)
 */
(function() {
    'use strict';

    // Only enable prefetch on desktop devices (not mobile touchscreens)
    if (!window.matchMedia('(hover: hover)').matches) {
        return; // Exit on touch-only devices
    }

    // Cache for prefetched images to prevent redundant requests
    var prefetchCache = {};

    /**
     * Prefetch product images for a swatch
     * @param {HTMLElement} swatch - The swatch element to prefetch
     */
    function prefetchSwatchImages(swatch) {
        var img = swatch.getAttribute('data-img');
        var img2 = swatch.getAttribute('data-img-2');

        // Prefetch primary image
        if (img && img.trim() && !prefetchCache[img]) {
            var preloadImg = new Image();
            preloadImg.src = img;
            prefetchCache[img] = true;
        }

        // Prefetch hover image
        if (img2 && img2.trim() && !prefetchCache[img2]) {
            var preloadImg2 = new Image();
            preloadImg2.src = img2;
            prefetchCache[img2] = true;
        }
    }

    /**
     * Prefetch swatches for above-the-fold products immediately
     * Ensures instant switching for products visible on page load
     */
    function prefetchAboveFold() {
        // Prefetch first 8 products (typically visible on desktop)
        var firstProducts = document.querySelectorAll('.grid-product[data-product-id], .gf-product-item[data-product-id]');
        var limit = Math.min(8, firstProducts.length);

        for (var i = 0; i < limit; i++) {
            var swatches = firstProducts[i].querySelectorAll('.t4s-pr-color__item[onclick]');
            swatches.forEach(function(swatch) {
                prefetchSwatchImages(swatch);
            });
        }
    }

    /**
     * Setup IntersectionObserver to watch for products entering viewport
     * @returns {IntersectionObserver} The created observer instance
     */
    function setupIntersectionObserver() {
        // Create observer that triggers 1500px before product enters viewport
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // Product card entered viewport - prefetch all its swatches
                    var productCard = entry.target;
                    var swatches = productCard.querySelectorAll('.t4s-pr-color__item[onclick]');

                    swatches.forEach(function(swatch) {
                        prefetchSwatchImages(swatch);
                    });

                    // Stop observing this product (prefetch only once)
                    observer.unobserve(productCard);
                }
            });
        }, {
            rootMargin: '0px 0px 1500px 0px', // Trigger 1.5 viewports before entering viewport
            threshold: 0.01 // Trigger as soon as 1% visible
        });

        // Observe all product cards (both standard and Globo Filter products)
        var productCards = document.querySelectorAll('.grid-product[data-product-id], .gf-product-item[data-product-id]');
        productCards.forEach(function(card) {
            observer.observe(card);
        });

        return observer;
    }

    // Store current observer instance for cleanup
    var currentObserver = null;

    /**
     * Initialize/reinitialize viewport prefetch observer
     * @param {boolean} delayAboveFold - Whether to delay above-fold prefetch (for initial page load)
     */
    function initPrefetch(delayAboveFold) {
        // Disconnect previous observer if exists
        if (currentObserver) {
            currentObserver.disconnect();
        }

        // Initialize observer immediately (no delay)
        currentObserver = setupIntersectionObserver();

        // Prefetch above-the-fold products
        if (delayAboveFold) {
            // Delay on initial page load to let critical resources load first
            setTimeout(prefetchAboveFold, 500);
        } else {
            // Immediate prefetch after filter changes (critical resources already loaded)
            prefetchAboveFold();
        }
    }

    // Initial setup on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initPrefetch(true); // Delay above-fold prefetch on initial load
        });
    } else {
        initPrefetch(true); // Delay above-fold prefetch on initial load
    }

    // Re-initialize after Globo Filter renders (products recreated on filtering)
    window.addEventListener('globoFilterRenderCompleted', function() {
        // Delay to ensure DOM updates and universal populator complete
        setTimeout(function() {
            initPrefetch(false); // No delay - critical resources already loaded
        }, 200);
    });

    // Re-initialize after AJAX product data loads (products 251-1000)
    // Universal populator runs after AJAX completes
    var mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                // Check if new product cards were added
                var hasProducts = Array.from(mutation.addedNodes).some(function(node) {
                    return node.nodeType === 1 && (
                        (node.classList && (node.classList.contains('grid-product') || node.classList.contains('gf-product-item'))) ||
                        (node.querySelector && node.querySelector('.grid-product, .gf-product-item'))
                    );
                });
                if (hasProducts) {
                    // Re-initialize observer to catch new products
                    setTimeout(function() {
                        initPrefetch(false); // No delay - critical resources already loaded
                    }, 100);
                }
            }
        });
    });

    // Observe product grid containers for dynamically added products
    var productGrid = document.querySelector('#gf-products');
    if (productGrid) {
        mutationObserver.observe(productGrid, { childList: true, subtree: true });
    }

    // Also observe main collection grid (non-Globo Filter pages)
    var collectionGrid = document.querySelector('.grid--uniform');
    if (collectionGrid) {
        mutationObserver.observe(collectionGrid, { childList: true, subtree: true });
    }
})();

function handleSelectChange(selectElement) {
    var selectedValue = selectElement.value;
    window.location.href = selectedValue;
}

/*Accordian js*/
var acc = document.getElementsByClassName("tab-title");
var i;

for (i = 0; i < acc.length; i++) {	
    acc[i].onclick = function() {	
        var panel = this.nextElementSibling;
        var coursePanel = document.getElementsByClassName("tab-panel");
        var courseAccordion = document.getElementsByClassName("tab-title");
        var courseAccordionActive = document.getElementsByClassName("tab-title active");
    
        if (panel.style.maxHeight){
            panel.style.maxHeight = null;
    		this.classList.remove("active");
        } else {
            for (var ii = 0; ii < courseAccordionActive.length; ii++) {
                courseAccordionActive[ii].classList.remove("active");
            }
            for (var iii = 0; iii < coursePanel.length; iii++) {
                this.classList.remove("active");
                coursePanel[iii].style.maxHeight = null;
    		}  
            panel.style.maxHeight = panel.scrollHeight + "px"; 
            this.classList.add("active");
        } 
    }
}


/*table top & bottom Scroll Code*/
function doubleScroll(element) {
    const scrollbar = document.createElement("div");
    scrollbar.appendChild(document.createElement("div"));
    scrollbar.style.overflow = "auto";
    scrollbar.style.overflowY = "hidden";
    scrollbar.classList.add("table-wrapper-scroll");
    scrollbar.firstChild.style.width = element.scrollWidth + "px";
    scrollbar.firstChild.style.paddingTop = "1px";
    scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));
    let running = false;
    // Keep scrollbar in sync when element size changes
    new ResizeObserver(() => {
        scrollbar.firstChild.style.width = element.scrollWidth + "px";
    }).observe(element);
    scrollbar.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
}

document.addEventListener("DOMContentLoaded", () => {
    var tables = document.querySelectorAll('#doubleScroll .table-wrapper');
    tables.forEach((table) => {
        doubleScroll(table);            
    });

    const buttonRightS = document.querySelectorAll('.scroll-arrow button.right');
    const buttonLeftS = document.querySelectorAll('.scroll-arrow button.left');
    
    buttonRightS.forEach((buttonRight) => {
        buttonRight.onclick = function () {
            document.querySelector('#doubleScroll .table-wrapper').scrollLeft += 150;
        };
    });
    buttonLeftS.forEach((buttonLeft) => {
        buttonLeft.onclick = function () {
            document.querySelector('#doubleScroll .table-wrapper').scrollLeft -= 150;
        };
    });
});

/*
 * Gift Wrap Product Dropdown Handler
 * Handles dropdown selection and adds gift wrap products to cart
 */
(function() {
    'use strict';

    // sessionStorage key for persisting gift message across interactions
    var GIFT_MESSAGE_STORAGE_KEY = 'gift_message_draft';

    // Handle dropdown selection change
    document.addEventListener('change', function(evt) {
        if (evt.target.id !== 'GiftWrapSelect') {
            return;
        }

        var select = evt.target;
        var selectedOption = select.options[select.selectedIndex];
        var preview = document.getElementById('GiftWrapPreview');
        var message = document.getElementById('GiftWrapMessage');
        var action = document.getElementById('GiftWrapAction');
        var button = document.getElementById('GiftWrapAddButton');
        var messageInput = document.getElementById('GiftMessageInput');
        var blankCheckbox = document.getElementById('GiftMessageBlankCheckbox');
        var closeButton = document.getElementById('GiftWrapClose');
        var giftInfo = document.querySelector('.gift-wrap-info');
        var giftInfoToggle = document.querySelector('.js-gift-info-toggle');
        var giftInfoText = document.getElementById('GiftInfoText');

        // If no selection (placeholder), hide all sections
        if (!select.value) {
            preview.style.display = 'none';
            message.style.display = 'none';
            action.style.display = 'none';
            button.disabled = true;
            closeButton.style.display = 'none';
            giftInfo.style.display = 'none';
            // Reset checkbox (message persists via sessionStorage)
            blankCheckbox.checked = false;
            messageInput.style.display = 'block';
            return;
        }

        // Show close button when product is selected
        closeButton.style.display = 'flex';

        // Get selected product data from option attributes
        var title = selectedOption.getAttribute('data-title');
        var image = selectedOption.getAttribute('data-image');
        var description = selectedOption.getAttribute('data-description');
        var showMessage = selectedOption.getAttribute('data-show-message');

        // Update preview
        document.getElementById('GiftWrapPreviewImage').src = image;
        document.getElementById('GiftWrapPreviewImage').alt = title;
        document.getElementById('GiftWrapPreviewDescription').innerHTML = description;
        preview.style.display = 'flex';

        // Conditionally show/hide message section and gift info based on product settings
        if (showMessage === 'true') {
            message.style.display = 'block';
            giftInfo.style.display = 'block';
            // Restore message from sessionStorage if available
            var savedMessage = sessionStorage.getItem(GIFT_MESSAGE_STORAGE_KEY);
            if (savedMessage) {
                messageInput.value = savedMessage;
                // Update character counter
                var counter = document.getElementById('GiftMessageCount');
                if (counter) {
                    counter.textContent = savedMessage.length;
                }
            }
        } else {
            message.style.display = 'none';
            giftInfo.style.display = 'none';
            // Reset gift info collapsed state
            if (giftInfoToggle) {
                giftInfoToggle.setAttribute('aria-expanded', 'false');
            }
            if (giftInfoText) {
                giftInfoText.style.display = 'none';
            }
            // Reset checkbox when hidden (message persists via sessionStorage)
            blankCheckbox.checked = false;
            messageInput.style.display = 'block';
        }

        // Store showMessage state for add-to-cart handler
        action.setAttribute('data-show-message', showMessage);

        // Show action section and enable add button
        action.style.display = 'block';
        button.disabled = false;
    });

    // Handle "Leave card blank" checkbox toggle
    document.addEventListener('change', function(evt) {
        if (evt.target.id !== 'GiftMessageBlankCheckbox') {
            return;
        }

        var checkbox = evt.target;
        var messageInput = document.getElementById('GiftMessageInput');

        if (checkbox.checked) {
            // Checkbox checked - hide/collapse textarea
            messageInput.style.display = 'none';
            messageInput.value = ''; // Clear any entered text
            sessionStorage.removeItem(GIFT_MESSAGE_STORAGE_KEY); // Clear persisted message
            // Reset character counter
            var counter = document.getElementById('GiftMessageCount');
            if (counter) {
                counter.textContent = '0';
            }
        } else {
            // Checkbox unchecked - show textarea
            messageInput.style.display = 'block';
        }
    });

    // Handle close button to reset gift wrap selection
    document.addEventListener('click', function(evt) {
        if (!evt.target.closest('.js-gift-wrap-close')) {
            return;
        }

        evt.preventDefault();

        var select = document.getElementById('GiftWrapSelect');
        if (select) {
            // Reset dropdown to first option (placeholder)
            select.selectedIndex = 0;
            // Trigger change event to hide all sections
            var changeEvent = new Event('change', { bubbles: true });
            select.dispatchEvent(changeEvent);
        }
    });

    // Handle gift info collapsible toggle
    document.addEventListener('click', function(evt) {
        if (!evt.target.closest('.js-gift-info-toggle')) {
            return;
        }

        evt.preventDefault();

        var button = evt.target.closest('.js-gift-info-toggle');
        var textElement = document.getElementById('GiftInfoText');
        var isExpanded = button.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            // Collapse
            button.setAttribute('aria-expanded', 'false');
            textElement.style.display = 'none';
        } else {
            // Expand
            button.setAttribute('aria-expanded', 'true');
            textElement.style.display = 'block';
        }
    });

    // Filter gift message input to only allow English alphabet, numbers, spaces, and basic punctuation
    document.addEventListener('input', function(evt) {
        if (evt.target.id !== 'GiftMessageInput') {
            return;
        }

        var input = evt.target;

        // Only apply validation if data attribute is present
        if (!input.hasAttribute('data-character-validation')) {
            return;
        }

        // Allow: English letters (a-z, A-Z), numbers (0-9), spaces, basic punctuation (.,!?'"-), line breaks
        // Pattern: match anything NOT in the allowed set
        var allowedPattern = /[^a-zA-Z0-9\s.,!?'"\-\n\r]/g;

        // Store cursor position before filtering
        var cursorPosition = input.selectionStart;
        var originalLength = input.value.length;

        // Remove invalid characters
        var filteredValue = input.value.replace(allowedPattern, '');

        // Update value if it changed
        if (input.value !== filteredValue) {
            input.value = filteredValue;

            // Restore cursor position, adjusted for removed characters
            var newLength = filteredValue.length;
            var removedChars = originalLength - newLength;
            var newCursorPosition = Math.max(0, cursorPosition - removedChars);
            input.setSelectionRange(newCursorPosition, newCursorPosition);
        }

        // Save message to sessionStorage for persistence across interactions
        sessionStorage.setItem(GIFT_MESSAGE_STORAGE_KEY, input.value);

        // Update character counter
        var counter = document.getElementById('GiftMessageCount');
        if (counter) {
            counter.textContent = input.value.length;
        }
    });

    // Handle add to cart button click
    document.addEventListener('click', function(evt) {
        if (!evt.target.classList.contains('js-add-gift-wrap-dropdown')) {
            return;
        }

        var button = evt.target;
        var select = document.getElementById('GiftWrapSelect');
        var variantId = select.value;

        if (!variantId) {
            console.error('Gift wrap variant ID not found');
            return;
        }

        // Show loading state
        var originalText = button.textContent;
        button.textContent = "Adding...";
        button.disabled = true;
        button.classList.add('btn--loading');

        // Check if message box was shown for this product
        var action = document.getElementById('GiftWrapAction');
        var showMessage = action.getAttribute('data-show-message');
        var messageInput = document.getElementById('GiftMessageInput');
        var blankCheckbox = document.getElementById('GiftMessageBlankCheckbox');

        // Build properties object
        var properties = {
            '_show_message': showMessage // Store show_message setting (hidden)
        };

        // Only add unique ID and Gift Message when message box is enabled (each message is unique)
        if (showMessage === 'true') {
            properties['_gift_item_id'] = Date.now().toString(); // Unique identifier for items with messages

            var giftMessage = 'blank'; // Default to "blank"

            // Only use actual message text if checkbox is unchecked AND there's a non-empty message
            if (!blankCheckbox.checked && messageInput.value && messageInput.value.trim()) {
                giftMessage = messageInput.value.trim();
            }

            properties['Gift Message'] = giftMessage;
        }

        // Prepare cart add with unique properties for each gift item
        var requestBody = JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1,
                properties: properties
            }]
        });

        // Add to cart using existing cart API pattern
        fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: requestBody,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(item) {
            console.log('Gift wrap add response:', item);

            // Trigger cart rebuild to update cart drawer
            document.dispatchEvent(new CustomEvent('cart:build'));

            // Reset UI after brief delay
            setTimeout(function() {
                button.textContent = originalText;
                button.disabled = false;
                button.classList.remove('btn--loading');

                // Reset dropdown and trigger change event to hide all sections
                select.selectedIndex = 0;
                var changeEvent = new Event('change', { bubbles: true });
                select.dispatchEvent(changeEvent);

                // Clear persisted gift message after successful add
                sessionStorage.removeItem(GIFT_MESSAGE_STORAGE_KEY);
                // Clear textarea value
                if (messageInput) {
                    messageInput.value = '';
                }
                // Reset character counter
                var counter = document.getElementById('GiftMessageCount');
                if (counter) {
                    counter.textContent = '0';
                }
            }, 500);
        })
        .catch(function(error) {
            console.error('Error adding gift wrap to cart:', error);
            console.log('Full error details:', error, error.response);
            alert('Sorry, there was an error adding gift wrap to your cart. Please try again.');

            // Reset button state on error
            button.textContent = originalText;
            button.disabled = false;
            button.classList.remove('btn--loading');
        });
    });

    /**
     * Gift Wrap Product Modal
     * Initialize modal and handle product detail viewing
     */
    (function initGiftWrapModal() {
        // Initialize theme.Modals for gift wrap modal
        var giftWrapModal = null;
        if (typeof theme !== 'undefined' && typeof theme.Modals !== 'undefined') {
            giftWrapModal = new theme.Modals('GiftWrapModal', 'gift-wrap-modal', {
                closeOffContentClick: true,
                solid: false
            });
        }

        // Handle preview image button click - fetch data THEN open modal
        document.addEventListener('click', function(evt) {
            if (!evt.target.closest('.js-gift-wrap-modal-trigger')) {
                return;
            }

            evt.preventDefault();

            // Get currently selected product handle from dropdown
            var select = document.getElementById('GiftWrapSelect');
            if (!select || !select.value) {
                console.error('Gift wrap product not selected');
                return;
            }

            var selectedOption = select.options[select.selectedIndex];
            var productHandle = selectedOption.getAttribute('data-handle');

            if (!productHandle) {
                console.error('Product handle not found');
                return;
            }

            console.log('Fetching gift wrap product:', productHandle);

            // Fetch product data, populate modal, THEN open it
            fetchAndPopulateModal(productHandle);
        });

        // Handle free gift bar link click - opens same modal
        document.addEventListener('click', function(evt) {
            if (!evt.target.closest('.js-free-gift-modal-trigger')) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            // Get product handle from free gift bar
            var giftBar = document.querySelector('.free-gift-bar');
            if (!giftBar) {
                console.error('Free gift bar not found');
                return;
            }

            var productHandle = giftBar.getAttribute('data-product-handle');
            if (!productHandle) {
                console.error('Free gift product handle not found');
                return;
            }

            console.log('Fetching free gift product:', productHandle);

            // Fetch product data, populate modal, THEN open it (reuses same function)
            fetchAndPopulateModal(productHandle);
        });

        /**
         * Fetch product data, populate modal content, then open modal
         * @param {string} handle - Product handle
         */
        function fetchAndPopulateModal(handle) {
            // Fetch product JSON
            fetch('/products/' + handle + '.js')
                .then(function(response) {
                    if (!response.ok) {
                        throw new Error('Failed to fetch product: ' + response.status);
                    }
                    return response.json();
                })
                .then(function(product) {
                    console.log('Product data received:', product);

                    // Populate modal title
                    var titleElement = document.getElementById('GiftWrapModalTitle');
                    if (titleElement) {
                        titleElement.textContent = product.title;
                    }

                    // Populate modal price
                    var priceElement = document.getElementById('GiftWrapModalPrice');
                    if (priceElement && typeof theme !== 'undefined' && theme.Currency) {
                        var formattedPrice = theme.Currency.formatMoney(product.price, theme.moneyFormat);
                        priceElement.innerHTML = '<span class="money">' + formattedPrice + '</span>';
                    }

                    // Populate modal description
                    var descElement = document.getElementById('GiftWrapModalDescription');
                    if (descElement) {
                        descElement.innerHTML = product.description || 'No description available.';
                    }

                    // Populate modal images
                    var imagesContainer = document.getElementById('GiftWrapModalImages');
                    if (imagesContainer) {
                        imagesContainer.innerHTML = ''; // Clear existing images

                        if (product.images && product.images.length > 0) {
                            product.images.forEach(function(imageUrl, index) {
                                var imageDiv = document.createElement('div');
                                imageDiv.className = 'gift-wrap-modal__image-item';

                                var img = document.createElement('img');
                                img.src = imageUrl.replace(/\.jpg|\.png|\.jpeg/g, '_600x600$&');
                                img.alt = product.title;
                                img.className = 'gift-wrap-modal__image photoswipe__image';
                                img.setAttribute('data-mfp-src', imageUrl.replace(/\.jpg|\.png|\.jpeg/g, '_1200x1200$&'));
                                img.loading = index === 0 ? 'eager' : 'lazy';

                                imageDiv.appendChild(img);
                                imagesContainer.appendChild(imageDiv);
                            });

                            // Initialize PhotoSwipe if available and more than one image
                            if (product.images.length > 1 && typeof theme !== 'undefined' && typeof theme.Photoswipe !== 'undefined') {
                                setTimeout(function() {
                                    new theme.Photoswipe(imagesContainer);
                                }, 100);
                            }
                        } else {
                            imagesContainer.innerHTML = '<p>No images available.</p>';
                        }
                    }

                    // NOW open the modal after content is populated
                    if (giftWrapModal) {
                        console.log('Opening gift wrap modal');
                        giftWrapModal.open();
                    } else {
                        console.error('Gift wrap modal not initialized');
                    }
                })
                .catch(function(error) {
                    console.error('Error fetching gift wrap product data:', error);
                    alert('Sorry, we could not load the product details. Please try again.');
                });
        }
    })();

    // Reopen cart drawer when gift wrap modal closes
    document.addEventListener('modalClose.GiftWrapModal', function() {
        // Add small delay for smooth transition between modal close and drawer open
        setTimeout(function() {
            document.dispatchEvent(new CustomEvent('cart:open'));
        }, 100);
    });

    /**
     * Product Page Gift Message
     * Handle gift message input on packaging product pages
     */
    (function initProductGiftMessage() {
        var messageInput = document.getElementById('ProductGiftMessageInput');
        var blankCheckbox = document.getElementById('ProductGiftMessageBlankCheckbox');
        var messageCounter = document.getElementById('ProductGiftMessageCount');
        var messageProperty = document.getElementById('ProductGiftMessageProperty');
        var giftItemIdProperty = document.getElementById('ProductGiftItemId');
        var showMessageInput = document.getElementById('ProductShowMessage');

        // Exit if not on a product page with gift message component (need at least _show_message input)
        if (!showMessageInput) {
            return;
        }

        // Generate unique gift item ID only when message box is enabled
        if (giftItemIdProperty) {
            var uniqueId = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            giftItemIdProperty.value = uniqueId;
        }

        // Move hidden inputs inside the form so they submit with the form
        var productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
            // Always move _show_message (always rendered)
            if (showMessageInput) {
                productForm.appendChild(showMessageInput);
            }

            // Only move these if they exist (conditionally rendered when message box enabled)
            if (giftItemIdProperty) {
                productForm.appendChild(giftItemIdProperty);
            }
            if (messageProperty) {
                productForm.appendChild(messageProperty);
            }
        }

        // Initialize message property to "blank" (default value when textarea is empty)
        if (messageProperty) {
            messageProperty.value = 'blank';
        }

        // Only set up message box event listeners if message box is enabled
        if (!messageInput || !blankCheckbox) {
            return; // Exit early if message box is disabled - inputs already moved to form
        }

        // Handle character counter and validation for product page
        messageInput.addEventListener('input', function() {
            // Character validation - allow English letters, numbers, spaces, basic punctuation
            var allowedPattern = /[^a-zA-Z0-9\s.,!?'"\-\n\r]/g;

            var cursorPosition = messageInput.selectionStart;
            var originalLength = messageInput.value.length;

            var filteredValue = messageInput.value.replace(allowedPattern, '');

            if (messageInput.value !== filteredValue) {
                messageInput.value = filteredValue;
                var newLength = filteredValue.length;
                var removedChars = originalLength - newLength;
                var newCursorPosition = Math.max(0, cursorPosition - removedChars);
                messageInput.setSelectionRange(newCursorPosition, newCursorPosition);
            }

            // Update character counter
            if (messageCounter) {
                messageCounter.textContent = messageInput.value.length;
            }

            // Update hidden property field
            if (messageProperty) {
                messageProperty.value = messageInput.value.trim() || 'blank';
            }
        });

        // Handle "leave card blank" checkbox
        blankCheckbox.addEventListener('change', function() {
            if (blankCheckbox.checked) {
                // Hide textarea
                messageInput.style.display = 'none';
                messageInput.value = '';

                // Set property to "blank"
                if (messageProperty) {
                    messageProperty.value = 'blank';
                }

                // Reset counter
                if (messageCounter) {
                    messageCounter.textContent = '0';
                }
            } else {
                // Show textarea
                messageInput.style.display = 'block';

                // Clear property
                if (messageProperty) {
                    messageProperty.value = '';
                }
            }
        });

        // Clear form after successful add to cart
        document.addEventListener('ajaxProduct:added', function() {
            // Only clear if this is a packaging product page
            if (!messageInput) {
                return;
            }

            // Reset form
            messageInput.value = '';
            blankCheckbox.checked = false;
            messageInput.style.display = 'block';

            if (messageProperty) {
                messageProperty.value = '';
            }

            if (messageCounter) {
                messageCounter.textContent = '0';
            }

            // Generate new unique ID for next add
            uniqueId = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            if (giftItemIdProperty) {
                giftItemIdProperty.value = uniqueId;
            }
        });
    })();

    /**
     * Update eco-friendly note visibility
     * Ensures eco note is always visible
     */
    function updateEcoNoteVisibility() {
        var ecoNotes = document.querySelectorAll('.cart-eco-note');
        ecoNotes.forEach(function(ecoNote) {
            ecoNote.style.display = 'flex';
        });
    }

    // Update eco note visibility on cart changes
    document.addEventListener('cart:build', updateEcoNoteVisibility);
    document.addEventListener('cart:updated', updateEcoNoteVisibility);

    // Update on page load / drawer open
    updateEcoNoteVisibility();
})();

/*
 * Free Shipping Threshold Progress Bar Updater
 * Updates progress bar and message when cart changes
 */
(function() {
    'use strict';

    function updateFreeShippingBar() {
        // Get all free shipping bar elements
        var shippingBars = document.querySelectorAll('.free-shipping-bar');

        if (shippingBars.length === 0) {
            return; // Feature not enabled or bar not in DOM
        }

        // Fetch current cart data
        fetch('/cart.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(cart) {
                var currentTotal = cart.total_price;

                // Update each shipping bar instance
                shippingBars.forEach(function(bar) {
                    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
                    var countryMatched = bar.getAttribute('data-country-matched');

                    if (!threshold || isNaN(threshold)) {
                        return; // Invalid threshold
                    }

                    // Hide bar if country doesn't match threshold list
                    if (countryMatched === 'false') {
                        bar.style.display = 'none';
                        return;
                    }

                    // Show bar if country matches
                    bar.style.display = '';
                    var remaining = threshold - currentTotal;
                    var percentage = Math.min(100, Math.round((currentTotal / threshold) * 100));

                    var messageElement = bar.querySelector('.free-shipping-bar__message');
                    var fillElement = bar.querySelector('.free-shipping-bar__fill');

                    if (!messageElement || !fillElement) {
                        return; // Elements not found
                    }

                    // Update progress bar width
                    fillElement.style.width = percentage + '%';

                    // Update message and styling based on threshold status
                    if (remaining <= 0) {
                        // Threshold met - success state
                        messageElement.innerHTML = '✓ Your order now ships free';
                        fillElement.classList.add('free-shipping-bar__fill--complete');
                    } else {
                        // Still need more - show remaining amount
                        var formattedRemaining = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
                        messageElement.innerHTML = 'You\'re <strong>' + formattedRemaining + '</strong> away from free shipping';
                        fillElement.classList.remove('free-shipping-bar__fill--complete');
                    }
                });
            })
            .catch(function(error) {
                console.error('Error updating free shipping bar:', error);
            });
    }

    // Update shipping bar on cart changes
    document.addEventListener('cart:build', updateFreeShippingBar);
    document.addEventListener('cart:updated', updateFreeShippingBar);
    document.addEventListener('ajaxProduct:added', updateFreeShippingBar);

    // Update on page load
    updateFreeShippingBar();
})();

/*
 * Free Gift Progress Bar (Valentine's)
 * Auto-adds/removes gift product based on cart threshold
 */
(function() {
    'use strict';

    var isProcessing = false; // Prevent duplicate add/remove requests
    var cachedGiftProduct = null; // Pre-fetched product data

    function prefetchGiftProduct(handle) {
        if (!handle || cachedGiftProduct) return;

        fetch('/products/' + handle + '.js')
            .then(function(response) {
                if (!response.ok) return null;
                return response.json();
            })
            .then(function(product) {
                if (product && product.available) {
                    cachedGiftProduct = {
                        variantId: product.variants[0].id,
                        available: true
                    };
                }
            })
            .catch(function() {
                // Silent fail - will fetch on demand if needed
            });
    }

    function updateFreeGiftBar() {
        var giftBar = document.querySelector('.free-gift-bar');
        if (!giftBar) return;

        // Get AUD threshold and convert to local currency using Shopify's rate
        var thresholdAud = parseInt(giftBar.getAttribute('data-threshold-aud'), 10) || 15000;
        var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
        var threshold = Math.round(thresholdAud * rate);

        var productHandle = giftBar.getAttribute('data-product-handle');

        if (!threshold || !productHandle) return;

        fetch('/cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
                // Check if product exists in cart (any instance - manual or auto-added)
                var productInCart = cart.items.some(function(item) {
                    return item.handle === productHandle;
                });

                // Find specifically the auto-added free gift (has _free_gift property)
                var freeGiftItem = cart.items.find(function(item) {
                    return item.handle === productHandle &&
                           item.properties &&
                           item.properties._free_gift === 'true';
                });

                var cartTotal = cart.total_price;

                // Auto-add/remove logic
                if (!isProcessing) {
                    // Add gift only if product not in cart at all
                    if (cartTotal >= threshold && !productInCart) {
                        addFreeGiftToCart(productHandle);
                    }
                    // Remove only the auto-added gift (manual items stay in cart)
                    else if (cartTotal < threshold && freeGiftItem) {
                        removeFreeGiftFromCart(freeGiftItem.key);
                    }
                }

                // Update UI based on cart total
                updateFreeGiftBarUI(giftBar, cartTotal, threshold, productInCart);
            })
            .catch(function(error) {
                console.error('Error updating free gift bar:', error);
            });
    }

    function addFreeGiftToCart(handle) {
        isProcessing = true;

        // Use cached data if available (saves one network call)
        if (cachedGiftProduct && cachedGiftProduct.available) {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: cachedGiftProduct.variantId,
                    quantity: 1,
                    properties: {
                        '_free_gift': 'true',
                        '_gift_item_id': Date.now().toString()
                    }
                })
            })
            .then(function() {
                isProcessing = false;
                document.dispatchEvent(new CustomEvent('cart:build'));
            })
            .catch(function(error) {
                console.error('Error adding free gift:', error);
                isProcessing = false;
            });
            return;
        }

        // Fallback: fetch product data if not cached
        fetch('/products/' + handle + '.js')
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Product not found');
                }
                return response.json();
            })
            .then(function(product) {
                if (!product.available) {
                    console.warn('Free gift product is not available');
                    isProcessing = false;
                    return Promise.reject('Product not available');
                }
                var variantId = product.variants[0].id;
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        properties: {
                            '_free_gift': 'true',
                            '_gift_item_id': Date.now().toString()
                        }
                    })
                });
            })
            .then(function() {
                isProcessing = false;
                document.dispatchEvent(new CustomEvent('cart:build'));
            })
            .catch(function(error) {
                console.error('Error adding free gift:', error);
                isProcessing = false;
            });
    }

    function removeFreeGiftFromCart(lineItemKey) {
        isProcessing = true;
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 })
        })
        .then(function() {
            isProcessing = false;
            // Trigger cart rebuild to update drawer
            document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function(error) {
            console.error('Error removing free gift:', error);
            isProcessing = false;
        });
    }

    function updateFreeGiftBarUI(bar, total, threshold, giftInCart) {
        var remaining = threshold - total;
        var percentage = Math.min(100, Math.round((total / threshold) * 100));
        var thresholdMet = remaining <= 0;
        var displayName = bar.getAttribute('data-display-name') || 'free gift';

        var messageEl = bar.querySelector('.free-gift-bar__message');
        var fillEl = bar.querySelector('.free-gift-bar__fill');

        if (messageEl) {
            var linkHtml = '<a href="#" class="free-gift-bar__link js-free-gift-modal-trigger">' + displayName + '</a>';
            if (thresholdMet) {
                messageEl.innerHTML = "You've unlocked a free " + linkHtml + "!";
            } else {
                var formatted = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
                messageEl.innerHTML = '<strong>' + formatted + '</strong> away from free ' + linkHtml;
            }
        }

        if (fillEl) {
            fillEl.style.width = percentage + '%';
            if (thresholdMet) {
                fillEl.classList.add('free-gift-bar__fill--complete');
            } else {
                fillEl.classList.remove('free-gift-bar__fill--complete');
            }
        }
    }

    // Update gift bar on cart changes
    document.addEventListener('cart:build', updateFreeGiftBar);
    document.addEventListener('cart:updated', updateFreeGiftBar);
    document.addEventListener('ajaxProduct:added', updateFreeGiftBar);

    // Pre-fetch gift product data on page load
    var giftBar = document.querySelector('.free-gift-bar');
    if (giftBar) {
        var handle = giftBar.getAttribute('data-product-handle');
        prefetchGiftProduct(handle);
    }

    // Update on page load
    updateFreeGiftBar();
})();

/*
 * AJAX Remove Handler for Gift Items
 * Prevents page reload when removing gift items from cart drawer
 */
(function() {
    'use strict';

    document.addEventListener('click', function(evt) {
        if (!evt.target.classList.contains('js-cart-remove-gift')) {
            return;
        }

        evt.preventDefault(); // Stop page navigation

        var key = evt.target.getAttribute('data-key');

        if (!key) {
            console.error('Cart item key not found');
            return;
        }

        // Use existing theme API to remove item (qty = 0)
        theme.cart.changeItem(key, 0)
            .then(function() {
                // Trigger cart rebuild to update drawer
                document.dispatchEvent(new CustomEvent('cart:build'));
            })
            .catch(function(error) {
                console.error('Error removing gift item:', error);
            });
    });
})();

/*
 * Auto-Refresh Cart Drawer on Open
 * Ensures cart contents are always up-to-date when drawer opens
 * Handles multi-tab scenarios and external cart modifications
 */
(function() {
    'use strict';

    // Listen for cart drawer opening completion
    document.addEventListener('drawerOpen.CartDrawer', function() {
        // Trigger cart rebuild to fetch fresh contents
        document.dispatchEvent(new CustomEvent('cart:build'));
    });
})();